<template>
    <div class="dayin">
        <div>填写须知:1.一拖一机需填写室外机及电源类型;2.如非标配请注明遥控器类型;3.本明细表仅接受电子版形式</div>
        <div class="table">
            <table style="width: 100%;margin-top: 20px;">
                <tr>
                    <td>机种</td>
                    <td>数量/单位</td>
                    <td>单价</td>
                    <td>金额</td>
                    <td>成套/单品</td>
                    <td>登录情况</td>
                </tr>
                <tr v-for="(item,index) in tableData.goods">
                    <td>{{item.goods_attr}}</td>
                    <td>{{item.goods_number}}</td>
                    <td>{{item.goods_price}}</td>
                    <td>{{item.goods_number*item.goods_price}}</td>
                    <td>{{item.style}}</td>
                    <td :rowspan="50" v-if="index === 0">项目编号:{{tableData.login_account}}</td>
                </tr>
            </table>
        </div>
        <div class="btm">
            <div class="item">项目地址:{{tableData.address}}</div>
            <div class="item">询货部门:{{tableData.user_store}}</div>
            <div class="item">询价人:{{tableData.post_name}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tableData: JSON.parse(localStorage.getItem('DayinData')),
                item: 4,
            }
        },
        created() {
            console.log(this.tableData);
        },
        mounted() {
            window.print()
        }
    }
</script>
<style lang="less" scoped>
    .dayin{
        text-align: center;
        /*margin-top: 20px;*/
    }
    .dayin .table{
        display: inline-block;
        width: 98%;
        table,table tr th, table tr td { border:1px solid #000000; }
        table{
            text-align: center; border-collapse: collapse;line-height:27px;
            input{
                border: 0px;
            }

        }
    }
    .dayin .btm{
        width: 50%;
        margin-left: 25%;
        display: inline-block;
        text-align: left;
        .item{
            margin: 10px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/Dayin.vue